import { render, staticRenderFns } from "./HelpBubbleComponent.vue?vue&type=template&id=384be970&"
import script from "./HelpBubbleComponent.vue?vue&type=script&lang=ts&"
export * from "./HelpBubbleComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('384be970')) {
      api.createRecord('384be970', component.options)
    } else {
      api.reload('384be970', component.options)
    }
    module.hot.accept("./HelpBubbleComponent.vue?vue&type=template&id=384be970&", function () {
      api.rerender('384be970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Elements/HelpBubbleComponent.vue"
export default component.exports